import { CustomTableColor } from "components/dynamic-table/color-table";
import {
  tabelaPropostaColumns,
  TablePropostaRowProps,
  useTabelaPropostaFilters
} from "./utils";
import { Box } from "@chakra-ui/react";
import { FilterAbaProposta } from "./filter/text-filter";
import { useState } from "react";
import { useApplicationContext } from "contexts/ApplicationContext";
import { useRouter } from "router-manager/parts";

export function AbaPropostas() {
  const [rows, setRows] = useState<TablePropostaRowProps[]>([]);
  let [customerId, setCustomerId] = useState<number>();
  const { user } = useApplicationContext();
  const filterControl = useTabelaPropostaFilters({
    customer_id: customerId || user.userData.customerId!,
    setRows
  });
  const { onChange, filter, isLoading } = filterControl;
  const router = useRouter();

  return (
    <Box w="100%">
      <FilterAbaProposta
        filterControl={filterControl}
        setCustomerId={setCustomerId}
        onChange={onChange}
      />
      <Box w="100%" px="30px" pt="40px">
        <CustomTableColor
          columns={tabelaPropostaColumns({ setRows, router })}
          rows={rows}
          isLoading={isLoading}
          onNextPage={() => {
            onChange(filter.page + 1, "page");
          }}
          onPrevPage={() => {
            onChange(filter.page - 1, "page");
          }}
          onFirstPage={() => {
            onChange(0, "page");
          }}
          currentPage={filter.page}
        />
      </Box>
    </Box>
  );
}
